export default function (axios) {
  return {
    // /ossApi/getStsCredential 获取COS浏览器直传STS临时密钥(前端直传cos-js-sdk-v5用)
    getStsCredential(params) {
      return axios.post("/ossApi/getStsCredential", null, {
        params
      });
    }
  }
}